import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';

import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumnPlanMinimalMode.html?raw';

import DatePicker from '../../../moreCore/UI/DatePicker/DatePicker';
import "../../../moreCore/UI/DatePicker/DatePicker";
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
import "../../../moreCore/UI/FilterPanel/FilterPanel";

import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';

import MonthColumnPlanManager from '../MonthColumnPlanManager/MonthColumnPlanManager';

class MonthColumnPlanMinimalMode extends compose(_TabEnabledMixin) {
    templateString: any = template;

    mainWidget: MdsLax<InstanceType<typeof MonthColumnPlanManager>>;

    monthColumnPlanContainer: HTMLDivElement;

    mainDatePicker: MdsLax<InstanceType<typeof DatePicker>>;
    mainFilterPanel: MdsLax<InstanceType<typeof FilterPanel>>;
    myFilterPanelContainer: HTMLDivElement;

    secondFilterPanel: MdsLax<InstanceType<typeof FilterPanel>>;
    viewSettingsContainer: HTMLDivElement;

    checkBoxToggleEmptyDays: MdsLax<InstanceType<typeof CheckBox>>;


    viewDateStart: Date;
    viewDateEnd: Date;

    viewDateMain: Date;
    viewSpread: number = 1;


    fancyDatePickerDivContainer: HTMLDivElement;

    private jumpToDateQueue: Array<Date> = [];

    private flagShowEmptyDays = true;

    public toggleMinimalMode(showMode: boolean) {
        this.mainWidget.emit("useMinimalMode", showMode);
    }
    public toggleShowEmptyDays(showEmptyDays: boolean) {
        this.mainWidget.emit("minimalModeToggleShowEmptyDays", showEmptyDays);
        this.flagShowEmptyDays = showEmptyDays;
    }

    private _onHandle_DatePickerChange() {
        let currentSelectedDate = this.mainDatePicker.getValue();
        let jumpToDate = true;
        if ((typeof currentSelectedDate == 'undefined') || (currentSelectedDate == null)) {
            currentSelectedDate = this.mainDatePicker.getDisplayedMonth();
            jumpToDate = false;
        }
        currentSelectedDate.setMilliseconds(1);
        this.mainWidget.monthColumnPlan.removeAllMonths();
        this.updateViewDatesBySelectedDate((new Date(currentSelectedDate.toDateString())));
        this.updateStaticAppointsmentByFilterPanel();
        if (jumpToDate) {
            this.jumpToDateQueue.push(currentSelectedDate);
        }
    }

    private _onChange_ToggleEmptyDays(toggle: boolean) {
        this.flagShowEmptyDays = toggle;
        this.mainWidget.emit("useMinimalMode", false);
        this.mainWidget.emit("minimalModeToggleShowEmptyDays", this.flagShowEmptyDays);
        this.mainWidget.emit("useMinimalMode", true);
    }
    private _onHandle_StaticAppoitnmentsReloaded() {
        this.mainWidget.emit("useMinimalMode", false);
        this.mainWidget.emit("useMinimalMode", true);
        this.mainWidget.emit("minimalModeToggleShowEmptyDays", this.flagShowEmptyDays);
    }

    private _onHandle_LoadMainFilterPanelConfig(filterPanelConfig: any) {
        this.mainFilterPanel = new FilterPanel();
        this.mainFilterPanel.setConfig(filterPanelConfig);
        this.mainFilterPanel.placeAt(this.myFilterPanelContainer);
        this.mainDatePicker.on("change", lang.hitch(this, this._onHandle_DatePickerChange));
        this.mainDatePicker.on("pageChange", lang.hitch(this, this._onHandle_DatePickerChange));
        this.mainFilterPanel.on("change", lang.hitch(this, this._Handle_FilterPanelChange));
        this.updateStaticAppointsmentByFilterPanel();
    }

    private flagFilterPanelChangeIsPending = false;
    private _Handle_FilterPanelChange() {
        if (this.flagFilterPanelChangeIsPending == true) {
            return;
        }
        this.flagFilterPanelChangeIsPending = true;
        setTimeout(lang.hitch(this, () => {
            this.flagFilterPanelChangeIsPending = false;
            this.updateStaticAppointsmentByFilterPanel();
        }), 1000);
    }

    private updateStaticAppointsmentByFilterPanel() {
        this.mainFilterPanel.StandbyStart();
        this.mainWidget.StandbyStart();
        this.mainDatePicker.StandbyStart();
        this.mainDatePicker.domNode.classList.add("w3-disabled");
        this.mainDatePicker.domNode.classList.add("disabled");
        this.StandbyStart(this.viewSettingsContainer);
        this.RequestManager.callfunction(
            "MonthColumnPlan_API__GetExistingAppointmentsListJSONminimalMode",
            { filterOptions: this.mainFilterPanel.getData(), dateStart: this.viewDateStart, dateEnd: this.viewDateEnd },
            lang.hitch(this, this._onHandle_StaticAppointmentsUpdate),
            lang.hitch(this, (para) => { console.error("error fetching static appointments (minimal mode)", para) })
        )
    }

    private _onHandle_StaticAppointmentsUpdate(dataRes: Array<{ Class: string, ID: string, dateStart: string, dateEnd: string }>) {
        //setzt sachen im datepicker
        for (let day of dataRes["appointments"]) {
            let start = new Date(day.dateStart);
            let end = new Date(day.dateEnd);
            start.setHours(0, 0, 0, 1);
            end.setHours(23, 59, 59, 999);
            let monthDate = new Date(this.mainDatePicker.getDisplayedMonth().toDateString());

            //wir generieren uns einen array mit jeden tag im monat, waeren wir nicht mit es5 gefangen dann waere das ein 1-zeiler... :(
            const daysInMonth: Array<Date> = [];
            const daysInMonthCount = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
            for (let i = 1; i <= daysInMonthCount; i++) {
                daysInMonth.push(new Date(monthDate.getFullYear(), monthDate.getMonth(), i, 1, 0, 0));
            }
        }
        //setzt sachen im monatsplaner
        for (let month of this.mainWidget.monthColumnPlan.getAllMonths()) {
            for (let days of month.getAllDays()) {
                days.clearStaticData();
                days.staticValue = [];
                days.refreshDisplayValue();
            }
        }
        this.mainDatePicker.emptyAppointments();
        for (let appointment of dataRes["appointments"]) {
            let dateStart = new Date(appointment.dateStart);
            dateStart.setHours(0, 0, 0, 1);
            let dateEnd = new Date(appointment.dateEnd);
            dateEnd.setHours(23, 59, 59, 999);
            for (let month of this.mainWidget.monthColumnPlan.getAllMonths()) {
                for (let days of month.getAllDays()) {
                    let dayCheckDate = new Date(days.date.toDateString());
                    dayCheckDate.setHours(12);
                    if ((dateStart.getTime() <= dayCheckDate.getTime()) && (dayCheckDate.getTime() <= dateEnd.getTime())) {
                        days.staticValue.push(appointment);
                        days.refreshDisplayValue();
                        this.mainDatePicker.addAppointmentIcon(dayCheckDate, "fas fa-tag", dayCheckDate.toDateString(), appointment["bookingName"]);
                    }
                }
            }
        }
        this.toggleMinimalMode(false);
        this.toggleMinimalMode(true);
        this.toggleShowEmptyDays(!this.flagShowEmptyDays);
        this.toggleShowEmptyDays(!this.flagShowEmptyDays);
        if (this.jumpToDateQueue.length > 0) {
            let targetDate = this.jumpToDateQueue.shift();
            targetDate.setHours(0, 0, 0, 1)
            for (let month of this.mainWidget.monthColumnPlan.getAllMonths()) {
                for (let day of month.getAllDays()) {
                    let dayDate = new Date(day.date.toDateString());
                    dayDate.setHours(0, 0, 0, 1);
                    if (dayDate.getTime() == targetDate.getTime()) {
                        //wir scroll das element in die mitte des dokuments
                        if (day.domNode.classList.contains("w3-hide") == false) {
                            let elementMiddle = (day.domNode.getBoundingClientRect().top + window.scrollY) - (window.innerHeight / 2);
                            day.domNode.scrollIntoView({ behavior: 'auto' }); //scroll auf der x-axis (zb bei mobile moeglich), damit das suchende element immer schoen in view ist
                            window.scrollTo(0, elementMiddle); //wir scrollen nun das element in die mitte des bildschirms falls moeglich
                            helper_waitForScrollStop().then(lang.hitch(this, () => {
                                for (let nMonth of this.mainWidget.monthColumnPlan.getAllMonths()) {
                                    //wir holen uns des coole zeigsl nocheinmal aus der aktuellen planer heraus, da es sein kann, dass die dayrows zerstoert wurden
                                    for (let nDay of nMonth.getAllDays()) {
                                        let nDayDate = new Date(nDay.date.toDateString());
                                        nDayDate.setHours(0, 0, 0, 1);
                                        if (nDayDate.getTime() == targetDate.getTime()) {
                                            nDay.domNode.classList.add("quickHighlightBg");
                                            //tatsaechlich wird die dayrow spaeter zerstoert und damit auch alle eventlisteners. deshalb koennen wir einfach immer einen hier setzten ohne probleme
                                            nDay.domNode.addEventListener("animationend", lang.hitch(this, this.helperRemoveHighlightAnimation, day.domNode));
                                            return;
                                        }
                                    }
                                }
                            }));
                        }
                        //wir entfernen die auswahl, damit der user wieder das gleiche datum auswaehlen kann, falls er es aus irgend einen grund nicht findet...
                        this.mainDatePicker.removeCurrentSelect();
                        this.checkBoxToggleEmptyDays.setValue(true);
                        this.StandbyStop();
                        this.mainFilterPanel.StandbyStop();
                        this.mainDatePicker.StandbyStop();
                        this.mainWidget.StandbyStop();
                        this.mainDatePicker.domNode.classList.remove("w3-disabled");
                        this.mainDatePicker.domNode.classList.remove("disabled");
                        return;
                    }
                }
            }
        }
        this.checkBoxToggleEmptyDays.setValue(true, true);
        this.mainFilterPanel.StandbyStop();
        this.mainWidget.StandbyStop();
        this.mainDatePicker.StandbyStop();
        this.mainDatePicker.domNode.classList.remove("w3-disabled");
        this.mainDatePicker.domNode.classList.remove("disabled");
        this.StandbyStop();
    }

    private helperRemoveHighlightAnimation(element: HTMLElement) {
        try {
            if (element.classList.contains("quickHighlightBg") == true) {
                element.classList.remove("quickHighlightBg");
            }
        } catch {
            //edge case
            for (let elem of this.mainWidget.domNode.querySelector(".quickHighlightBg") as any) {
                if ((elem as HTMLElement).classList.contains("quickHighlightBg")) {
                    (elem as HTMLElement).classList.remove("quickHighlightBg");
                }
            }
        }
    }

    private updateViewDatesBySelectedDate(primaryDate: Date) {
        this.viewDateMain = primaryDate;

        let plus = new Date(this.viewDateMain.toISOString());
        let minus = new Date(this.viewDateMain.toISOString());
        plus.setMonth(plus.getMonth() + this.viewSpread);
        minus.setMonth(minus.getMonth() - this.viewSpread);
        minus.setDate(1); //setzt zum ersten tag des monats
        plus.setMonth(plus.getMonth() + 1); //setzt zum letzten tag des monats
        plus.setDate(0); //setzt zum letzten tag des monats
        this.viewDateStart = minus;
        this.viewDateEnd = plus;

        const startDate = this.viewDateStart;
        const endDate = this.viewDateEnd;

        const startYear = startDate.getFullYear();
        const startMonth = startDate.getMonth();
        const endYear = endDate.getFullYear();
        const endMonth = endDate.getMonth();
        const yearDifference = endYear - startYear;
        const monthDifference = endMonth - startMonth;
        const totalMonths = yearDifference * 12 + monthDifference;
        const monthCount = totalMonths + 1;

        this.mainWidget.monthColumnPlan.addMonthRange(this.viewDateStart, monthCount);
        this.mainWidget._onClick_ButtonSortAsc();
    }

    //#region postCreate
    continue_postCreate() { //wird aufgerufen nachdem dependencys in head injected wurden
        if (this.earlySelfKill()) return;
        this.mainWidget = new MonthColumnPlanManager();
        this.mainWidget.placeAt(this.monthColumnPlanContainer);
        this.mainDatePicker = new DatePicker();
        this.mainDatePicker.placeAt(this.fancyDatePickerDivContainer);
        let earliest = new Date(new Date().getFullYear() - 3, 0, 0);
        let highest = new Date(new Date().getFullYear() + 3, 0, 0);
        this.mainDatePicker.setup(new Date(), new Date(), earliest, highest, "agendaNavigation");
        this.mainWidget.emit("useMinimalMode", true);
        this.mainWidget.emit("minimalModeToggleShowEmptyDays", this.flagShowEmptyDays);
        this.mainWidget.on("staticAppointmentsReloaded", lang.hitch(this, this._onHandle_StaticAppoitnmentsReloaded));
        this.updateViewDatesBySelectedDate(new Date()); //setzt datum anzeige
        //Filter panel
        this.RequestManager.callfunction(
            "MonthColumnPlan_API__MinimalMode_GetFilterOptionsJSON",
            null,
            lang.hitch(this, this._onHandle_LoadMainFilterPanelConfig),
            lang.hitch(this, () => {
                console.error("MonthColumnPlanMinimalMode: unable to fetch filter panel config...");
                this.showToast(this.translations["General__ProcessFailed"], "far fa-dizzy");
            }),
        );
        this.checkBoxToggleEmptyDays.setValue(this.flagShowEmptyDays, true);//setzt checkbox nach flag
        this._onChange_ToggleEmptyDays(this.flagShowEmptyDays);
        this.monthColumnPlanContainer.classList.add("tfMinimalMode");
    }

    private earlySelfKill() {
        //da der tabcontainer nicht sofort das widget killen kann, muessen wir hier selber nocheinmal checken ob wir uns selber killen sollen :)
        if (this.hasFeature("MonthColumnPlaner", "minimalModeAgendaView") == false) {
            try {
                this.closeTab();
                this.destroy();
                return true;
            } catch {
                console.warn("unable to destroy monthcolumnplan minimal mode widget");
                this.domNode.innerHTML = "";
                return true;
            }

        }
        return false;
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        if (this.earlySelfKill()) return;
        this.initDependencys(); //-> continue_postCreate()

        this.addSubscription("EvBooking/Saved", lang.hitch(this, this.updateStaticAppointsmentByFilterPanel));
        this.addSubscription("EvBooking/Deleted", lang.hitch(this, this.updateStaticAppointsmentByFilterPanel));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    destroy(): void {
        clearTimeout(this.evisioHook_jumpToAppointmentTimeout);
    }

    //#region initDependencys
    private async initDependencys() {
        //setzt abhaenigkeiten in den header
        const dependency: Record<string, string[]> = {
            css: [
                "/Typescript/WidgetCollection/MonthColumnPlan_TS/css/style.css",
            ],
            js: []
        };
        for (let key in dependency) {
            for (let targetLink of dependency[key]) {
                let qsTarget = ""; //query select um zu testen, ob die elemente bereits zum head hinzugefuegt worden sind
                switch (key) {
                    case "css":
                        qsTarget = "head > link[rel = \"stylesheet\"][href = \"" + targetLink + "\"]"; //css
                        break;
                    case "js":
                        qsTarget = "head > script[src = \"" + targetLink + "\"]"; //js
                        break;
                }
                if ((document.querySelectorAll(qsTarget).length > 0) == false) {
                    //wurde noch nicht geladen
                    let res = await this.initLoadDependency(key, targetLink);
                    if (res != true) {
                        console.error("error loading sce editor");
                    }
                }
            }
        }
        this.continue_postCreate();
    }
    private async initLoadDependency(type: string, targetLink: string) {
        //ladded alle scripts fuer den sceditor, siehe initDependencys()
        switch (type) {
            case "css":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("link");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.href = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = () => reject(false);
                    document.head.appendChild(newCssElem);
                });
                break;
            case "js":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("script");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.src = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = (e) => reject(e);
                    document.head.appendChild(newCssElem);
                });
                break;
        }
    }

    private evisioHook_jumpToAppointmentTimeout: number;
    /**
     * Hook funktion fuer evisio, siehe EvisioChat.ts
     * @param appointmentData ID vom appointment zu dem wir springen wollen
     */
    public evisioHook_jumpToAppointment(appointmentData: { ID: string, displayName: string, start_date: string, end_date: string, activityStatus_code: string, activityStatus_id: string, venue_code: string, venue_id: string, }) {
        //FIXME - filter reset filter panel, gleich wie in EvBookingAgenda.ts

        let date = new Date(appointmentData.start_date);
        date.setHours(0, 0, 0, 0);
        this.mainDatePicker.setValue(date);
        //wir schauen ob der termin ueberhaupt sichtbar ist, wenn nein, dann pech solange wir das filter panel nicht zuruecksetzen koennen
        this.evisioHook_jumpToAppointmentTimeout = setTimeout(() => {
            let wasFound = false;
            for (let month of this.mainWidget.monthColumnPlan.getAllMonths()) {
                for (let day of month.getAllDays()) {
                    for (let appointment of day.staticValue) {
                        if (appointment.ID == appointmentData.ID) {
                            wasFound = true;
                        }
                    }
                }
            }
            if (wasFound == false) {
                this.showToast(this.translate("Evisio_jumpInAgenda_nothingToHighlight"), "far fa-eye-slash");
                console.error("(evisio_action jump in agenda) can't find appointment", appointmentData, this);
            }
        }, 2000);
    }

}

export default mdsWidget(MonthColumnPlanMinimalMode);


function helper_waitForScrollStop(fallbackTimeout: number = 2000): Promise<void> {
    return new Promise((resolve) => {
        let isScrolling: number | null = null;

        function onScroll() {
            if (isScrolling !== null) {
                clearTimeout(isScrolling);
            }

            isScrolling = window.setTimeout(() => {
                window.removeEventListener('scroll', onScroll);
                resolve();
            }, 100);
        }

        window.addEventListener('scroll', onScroll);

        // Fallback: wenn gar nicht gescrollt wurde
        setTimeout(() => {
            window.removeEventListener('scroll', onScroll);
            resolve();
        }, fallbackTimeout);
    });
}



/*
TODO LIST

minimal mode:
* add cshtml switch based on feature

*/
